import { Tooltip } from '../../Shared/Tooltip/Tooltip'
import {
  TUEV_CERTIFICATE_HEADLINE,
  TuevCertificateContent,
  TuevCertificateLogo
} from '../Content/TuevCertificateContent'

export const TuevCertificate = () => {
  return (
    <Tooltip
      role="tooltip"
      arrow
      placement="right"
      title={<TuevCertificateContent />}
      headline={TUEV_CERTIFICATE_HEADLINE}
    >
      <TuevCertificateLogo />
    </Tooltip>
  )
}
